import React, { Suspense } from "react";

import FallbackSearchBackendProvider from "../components/FallbackSearchBackendProvider";
import searchBackends from "../searchBackends";

export default function SearchBackendProvider({ settings, children }) {
  const Provider = React.lazy(searchBackends[settings.type]);
  return (
    <Suspense
      fallback={
        <FallbackSearchBackendProvider settings={settings}>
          {children}
        </FallbackSearchBackendProvider>
      }
    >
      <Provider settings={settings}>{children}</Provider>
    </Suspense>
  );
}
